import '../../pages/customerDashboard/styles.scss';
import {useEffect, useRef, useState} from "react";
import {Chart} from "react-google-charts";


interface DataItem {
    type: string;
    value: number;
}

interface FundChartProps {
    fundData: DataItem[]
}

const GoogleChart = (props: FundChartProps) => {
    const [formattedData, setFormattedData] = useState([["Fund", "Value"]]);
    const chartRef = useRef<HTMLDivElement>(null);
    const [chartWidth, setChartWidth] = useState(0);

    useEffect(() => {
        const transformedData = [["Fund", "Value"]].concat(
            props.fundData.map((item: DataItem) => [item.type, item.value])
        );

        setFormattedData(transformedData);
    }, [props.fundData]);

    const options = {
        width: chartWidth,
        pieHole: 0.6,
        is3D: false,
        sliceVisibilityThreshold: 0,
        slices: {
            0: {color: '#3b71ca'},
            1: {color: '#14a44d'},
            2: {color: '#E4A11B'},
            3: {color: '#DC4C64'},
            4: {color: '#9C27B0'},
            5: {color: '#607D8B'},
            6: {color: '#ff6838'},
            7: {color: '#795548'},
        },
        pieSliceText: 'none',
        legend: {
            alignment: 'center',
            textStyle: {fontSize: 12},
            pagingTextStyle: {fontSize: 12},
            position: 'right'
        },
        chartArea: {
            left: 40,
            top: 40,
            right: 40,
            bottom: 40,
            width: '100%',
            height: '100%',
        },
    };
    useEffect(() => {
        const handleResize = () => {
            if (chartRef.current) {
                setChartWidth(chartRef.current.offsetWidth);
            }
        };

        // Initial size
        handleResize();

        // Resize observer to watch for width changes
        const resizeObserver = new ResizeObserver(handleResize);
        if (chartRef.current) {
            resizeObserver.observe(chartRef.current);
        }

        return () => {
            if (chartRef.current) {
                resizeObserver.unobserve(chartRef.current);
            }
        };
    }, []);
    return (
        <div className={'dashboard-donut-chart-br'} ref={chartRef} style={{ width: '100%' }}>
            <Chart
                chartType="PieChart"
                width="100%"
                height="418px"
                data={formattedData}
                options={options}
            />
        </div>

    );
};

export default GoogleChart;
